import React from 'react';
import PropTypes from 'prop-types';

import { HorizontalBarChart } from 'modules/common/chart/BarChart';
import DelayDiv from 'modules/common/components/DelayDiv';
import OrgTable from './OrgTable';

const EmptyPlaceholder = () => (
  <div className="text-center pt-5">
    <svg
      className="mx-auto h-12 w-12 text-gray-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
      />
    </svg>
    <h3 className="mt-2 text-sm font-medium text-gray-900">Empty</h3>
    <p className="mt-1 text-sm text-gray-500">There are no items.</p>
  </div>
);

const format = [
  { id: 'title', label: 'ORGANIZATION', key: 'title' },
  {
    id: 'transactions',
    label: 'TRANSACTIONS',
    key: 'transactions',
    contentClassName: 'text-center',
  },
  { id: 'count', label: 'COLLECTIONS', key: 'count' },
];

const customChartPadding = {
  rightPadding: 10,
  leftPadding: 50,
};

function TopOrg({ data, isLoading }) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isLoading || !data?.length ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {isLoading ? (
            <div className="grid grid-cols-2 gap-3 p-3">
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="animate-pulse bg-gray-200 h-8 w-full rounded" />
            </div>
          ) : (
            <EmptyPlaceholder />
          )}
        </>
      ) : (
        <div className="flex justify-between">
          <div className="px-3 pt-1 pr-0 min-w-[37%]">
            <OrgTable data={data} format={format} isLoading={isLoading} />
          </div>
          <DelayDiv
            className="flex-grow"
            delay={100}
            loader={
              <div className="col-span-1 bg-gray-50 animate-pulse rounded-lg" />
            }
          >
            <HorizontalBarChart
              data={data}
              horizontal
              isLoading={isLoading}
              {...customChartPadding}
            />
          </DelayDiv>
        </div>
      )}
    </>
  );
}

TopOrg.defaultProps = {
  data: [],
  isLoading: false,
};

TopOrg.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.instanceOf(Array),
};

export default TopOrg;
